import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input, inject } from "@angular/core";
import { ICommercialSale } from "src/models/commercial/ICommercialSale";
import { CommercialSalesDataService } from "src/services/commercial/commercial-sales-data.service";
import { EvTooltipModule } from "ev-tooltip";
import { EvDirectivesModule } from "ev-directives";
import { EvCore } from "ev-core";

@Component({
    selector: "commercial-cluster-map-marker",
    imports: [CommonModule, EvTooltipModule, EvDirectivesModule, EvCore],
    templateUrl: "./commercial-cluster-map-marker.component.html",
    styleUrl: "./commercial-cluster-map-marker.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialClusterMapMarkerComponent {
    private readonly salesService = inject(CommercialSalesDataService);

    readonly data = input<ICommercialSale[]>();

    // Price range in millions (null when below 0.1) and the capped item count
    protected readonly summary = computed(() => {
        const data = this.data();
        if (data == null || data.length === 0) {
            return { minValue: undefined as number, maxValue: undefined as number, nrItems: 0 };
        }

        let minValue = 10000000000;
        let maxValue = 0;
        data.forEach((sale) => {
            const price = sale.askingPrice > 0 ? sale.askingPrice : sale.salesPrice;
            minValue = Math.min(minValue, price);
            maxValue = Math.max(maxValue, sale.askingPrice, sale.salesPrice);
        });

        minValue = minValue / 1000000;
        maxValue = maxValue / 1000000;

        return {
            minValue: minValue < 0.1 ? null : minValue,
            maxValue: maxValue < 0.1 ? null : maxValue,
            nrItems: Math.min(99, data.length),
        };
    });

    showSale(sale: ICommercialSale) {
        this.salesService.setSelectedSale(sale);
    }
}
